import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { addSelectedMessage, deleteSelectedMessage } from "../../store/slices/appSlice";
import { Checkbox } from "@mui/material";
import { createSelector } from "@reduxjs/toolkit";
const selectIsMessageSelected = createSelector((state) => state.app.selectedMessages, (_, messageID) => messageID, (selectedMessages, messageID) => selectedMessages.some(msg => msg.messageID === messageID));
const SelectMessageInput = ({ messageInfo }) => {
    const dispatch = useAppDispatch();
    const checked = useAppSelector(state => selectIsMessageSelected(state, messageInfo.messageID));
    const handleChange = useCallback(() => {
        if (checked) {
            dispatch(deleteSelectedMessage(messageInfo));
        }
        else {
            dispatch(addSelectedMessage(messageInfo));
        }
    }, [checked, dispatch, messageInfo]);
    console.log('render checkbox');
    return (_jsx(Checkbox, { checked: checked, onChange: handleChange }));
};
export default memo(SelectMessageInput);
